import { useState, useEffect } from 'react';
import * as Popover from '@radix-ui/react-popover';
import { Icon } from '@/ui/icons/Icon';
import { useError } from '@/providers/Error';
import styles from './ErrorHeaderPopover.module.scss';
import { warning } from '@/assets/images/emojis';
import { Button } from '@/ui/components';

interface ErrorHeaderPopoverProps {
  children: React.ReactElement;
  variant?: 'mobile' | 'desktop';
}

export function ErrorHeaderPopover({
  children,
  variant = 'mobile',
}: ErrorHeaderPopoverProps) {
  const { error, clearError } = useError();
  const [isErrorPopoverOpen, setIsErrorPopoverOpen] = useState(false);
  const isOpen = !!error && isErrorPopoverOpen;

  useEffect(() => {
    setIsErrorPopoverOpen(!!error);
  }, [error]);

  const handleErrorPopoverOpenChange = (open: boolean) => {
    setIsErrorPopoverOpen(open);
    if (!open && error) {
      clearError();
    }
  };

  const handleClose = () => {
    setIsErrorPopoverOpen(false);
    clearError();
  };

  return (
    <Popover.Root open={isOpen} onOpenChange={handleErrorPopoverOpenChange}>
      <Popover.Anchor asChild>{children}</Popover.Anchor>

      <Popover.Portal>
        <Popover.Content
          className={styles.popoverContent}
          side="bottom"
          align="end"
          alignOffset={variant === 'mobile' ? 0 : -46}
          sideOffset={variant === 'mobile' ? 26 : 6}
        >
          <div className={styles.popover}>
            <div className={styles.header}>
              <div className={styles.leftContainer}>
                <img src={warning} alt="Error" className={styles.icon} />
                <span className={styles.title}>Eroare</span>
              </div>

              <Button
                trackingId="close_error_popover"
                variant="text"
                size="xsmall"
                className={styles.closeButton}
                onClick={handleClose}
                aria-label="Închide"
                rightIcon={<Icon name="times" className={styles.closeIcon} />}
              />
            </div>
            <div className={styles.content}>
              <p className={styles.message}>{error}</p>
            </div>
          </div>
          <Popover.Arrow className={styles.popoverArrow} />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
